"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveUserCommunicationViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveUserCommunicationViewModel = function () {
        function FourFiveUserCommunicationViewModel(fourFiveUserCommunication) {
            _classCallCheck(this, FourFiveUserCommunicationViewModel);

            this.userId = ko.observable('');
            this.uniqueId = ko.observable('');
            this.communicationType = ko.observable('');
            this.messageType = ko.observable('');
            this.status = ko.observable('');
            this.sendGridStatusCode = ko.observable('');
            this.sentDate = ko.observable('');
            this.info = ko.observable('');
            this.emailAddress = ko.observable('');
            this.subject = ko.observable('');
            this.appId = ko.observable('');
            this.update(fourFiveUserCommunication);
        }

        _createClass(FourFiveUserCommunicationViewModel, [{
            key: "update",
            value: function update(fourFiveUserCommunication) {
                this.userId(fourFiveUserCommunication.userId);
                this.uniqueId(fourFiveUserCommunication.uniqueId);
                this.communicationType(fourFiveUserCommunication.communicationType);
                this.messageType(fourFiveUserCommunication.messageType);
                this.status(fourFiveUserCommunication.status);
                this.sendGridStatusCode(fourFiveUserCommunication.sendGridStatusCode);
                this.sentDate(moment(fourFiveUserCommunication.sentDate).format('DD/MM/YYYY HH:mm:ss'));
                this.info(fourFiveUserCommunication.info);
                this.emailAddress(fourFiveUserCommunication.emailAddress);
                this.subject(fourFiveUserCommunication.subject);
                this.appId(fourFiveUserCommunication.appId);
            }
        }, {
            key: "clear",
            value: function clear() {
                this.userId('');
                this.uniqueId('');
                this.communicationType('');
                this.messageType('');
                this.status('');
                this.sendGridStatusCode('');
                this.sentDate('');
                this.info('');
                this.emailAddress('');
                this.subject('');
                this.appId('');
            }
        }]);

        return FourFiveUserCommunicationViewModel;
    }();

    return FourFiveUserCommunicationViewModel;
});
//# sourceMappingURL=fourFiveUserCommunicationViewModel.js.map;
